// Константы для типов и размеров контейнеров

export const CONTAINER_SIZES = [
  { label: 'S', value: 'S' },
  { label: 'M', value: 'M' },
  { label: 'L', value: 'L' },
  { label: 'XL', value: 'XL' }
]

export const CONTAINER_TYPES = [
  { label: 'Стандартный', value: 'container' },
  { label: 'Термо', value: 'thermal_bag' },
  { label: 'Специальный', value: 'custom_type' }
]

export const CONTAINER_SIZE_LABELS = {
  'S': 'Маленький',
  'M': 'Средний', 
  'L': 'Большой',
  'XL': 'XL'
} as const

export const CONTAINER_TYPE_LABELS = {
  'container': 'Стандартный',
  'thermal_bag': 'Термо',
  'custom_type': 'Специальный'
} as const
